/*
 * Copyright (c) 2019 Pegasystems Inc.
 * All rights reserved.
 */
import { ofType } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { throttleUntilChanged } from '../../utils/rxjs-utils';
import { GETDATAOBJECTACTIONS, ERROR } from '../../store/state/actions';
import { processDataToDispatchErrorAction } from '../../store/state/epics/util';
import { ActionManagerInstance } from '../../actions/manager';
import { isErrorActionType } from '../../case/common-helper';
import { dispatch } from '../../store/state/state-manager';
import type { Action } from '../../store/state/state-manager';

import executeAsyncRequest from './async-request';
import type { ActionPayload, EndpointData, MapPayload } from './types';

const getDataObjectActions = (action$: Observable<Action>) => {
  let actionMgrID = 0;
  let theReturn: any[] = [];
  const throttleValue = 100;
  let actionResponse = {};

  return action$.pipe(
    ofType(GETDATAOBJECTACTIONS),
    throttleUntilChanged(throttleValue),
    map((action: MapPayload) => {
      ({ actionMgrID } = action.payload);
      return action.payload;
    }),
    mergeMap((payload: ActionPayload) => {
      return executeAsyncRequest(payload);
    }),
    mergeMap(async (data: EndpointData) => {
      if (data && data.type === ERROR) {
        // processDataToDispatchErrorAction calls ActionManagerInstance.rejectActionByID
        theReturn.push(processDataToDispatchErrorAction(data));
        return theReturn;
      }
      actionResponse = data;
      return [];
    }),
    map(() => {
      if (theReturn.length === 1 && isErrorActionType(theReturn[0].type)) {
        ActionManagerInstance.rejectActionByID(actionMgrID);
      } else {
        ActionManagerInstance.resolveActionByID(actionMgrID, actionResponse);
      }
      dispatch(theReturn);
      theReturn = [];
      return theReturn;
    })
  );
};

export default getDataObjectActions;
